<template>
  <div class="file-box">
    <template v-if="listType == 'picture-card'">
      <div class="fileitem-box" v-for="item in fileList" :key="item.id" :style="imgBoxStyle">
        <el-image :ref="(el) => imageRef[item.url] = el" v-if="'png.PNG.jpeg.jpg'.indexOf(item.fileSuffix) >= 0"
        :src="`${item.url}?Authorization=${getToken()}`" @click="previewSrcList(item)" style="width: 100%;height: 100%;"
        :z-index="2000" preview-teleported fit="fill" :url-list="urlList()" />
      <el-image v-if="'xlsx.xls'.indexOf(item.fileSuffix) >= 0" :src="fileExcel" @click="previewSrcList(item)"
        style="width: 100%;height: 100%;" :z-index="2000" preview-teleported fit="fill" />
      </div>
    </template>
    <div v-else>
      <el-link v-for="item in fileList" :key="item.id" type="primary" @click="toDownload(item)">
        {{ item.fileName }}
      </el-link>
    </div>
    <el-image-viewer v-if="dialogVisible" @close="closeImgViewer" :url-list="urlList()" :z-index="3000" />
  </div>
</template>

<script>
import fileExcel from "./img/file-excel.png";
import { getUploadFileId } from "@/utils/file.js";
import { listFileStorage } from "@/api/file/fileStorage";
import { getToken } from '@/utils/auth'
import { getUUID } from '@/utils/ruoyi.js'
import { reactive, toRefs, watch, getCurrentInstance } from 'vue'
import gljyImgPreview from "./gljy-img-preview.vue";
export default {
  name: "gljy-file",
  components: {
    gljyImgPreview
  },
  props: {
    fileUrls: {
      type: String,
    },
    // 是否开启懒加载
    lazy: {
      type: Boolean,
    },
    disabled: Boolean,
    imgBoxStyle: String,
    imgStyle: String,
    /** 'text' | 'picture-card' */
    listType: {
      type: String,
      default: "picture-card"
    },
    // 是否是外部图片地址
    isExternal: {
      type: Boolean,
      default: false
    },
    // 是否是图片地址
    fileSuffix: {
      type: Boolean,
      default: false
    },
  },
  setup(props, context) {
    const { proxy } = getCurrentInstance();
    const gljyImgPreviewRef = ref();
    const imageRef = ref({});
    const router = useRouter();
    const datas = reactive({
      getToken: getToken,
      baseUrl: import.meta.env.VITE_APP_BASE_API,
      fileList: [],
      fileExcel: fileExcel,
      dialogVisible: false,
    })

    const methods = {
      urlList() {
        return datas.fileList.map(item => item.url + `?Authorization=${getToken()}`);
      },
      previewSrcList(item) {
        if ('xlsx.xls.pdf.docx.png.PNG.jpeg.jpg'.indexOf(item.fileSuffix) < 0) {
          proxy.$modal.msgError(`系统当前只支持预览【.xlsx、.docx、.pdf文件和图片】`);
          return false;
        }
        if ('xlsx.xls.pdf.docx'.indexOf(item.fileSuffix) >= 0) {
          let type = "";
          if (item.fileSuffix.indexOf("pdf") > 0) {
            type = "pdf";
          } else if ('xlsx.xls'.indexOf(item.fileSuffix) >= 0) {
            type = "excel";
          } else if ('docx'.indexOf(item.fileSuffix) >= 0) {
            type = "docx";
          } else {
            return;
          }
          const fileRouter = router.resolve({
            path: "/file-preview",
            query: {
              fileId: props.fileId,
              url: item.url,
              type,
            },
          });
          window.open(fileRouter.href, "_blank");
        } else {
          datas.dialogVisible = true;
        }
      },
      //关闭预览
      closeImgViewer() {
        datas.dialogVisible = false
      },
      toDownload(item) {
        window.open(item.url);
      }
    }

    watch(() => props.fileUrls, async (fileUrls) => {
      datas.fileList = [];
      if (fileUrls && !props.isExternal) {
        const list = fileUrls.split(",");
        const fileIdList = list.map(url => getUploadFileId(url));
        const res = await listFileStorage({ fileIdList: fileIdList })
        list.forEach(url => {
          const fileItem = {
            id: getUUID()
          };
          if (res?.code == 200) {
            const find = res.rows.find(f => f.pathUri == url);
            fileItem.name = find.filePrefix;
            fileItem.fileSuffix = find.fileSuffix;
            fileItem.fileSize = find.fileSize;
          }
          if (url.indexOf("http://") == 0 || url.indexOf("https://") == 0) {
            fileItem.url = url
          } else {
            fileItem.url = datas.baseUrl + url;
          }
          // 截取文件名称---直接查询数据库
          if (!fileItem.fileName) {
            const urlList = url.split("/");
            const fileAllName = urlList[urlList.length - 1];
            const fileName = fileAllName.split("_")[0];
            fileItem.fileName = fileName;
            // console.log("fileItem", fileItem)
          }
          datas.fileList.push(fileItem);
        })
      }else if (fileUrls && props.isExternal) {
        const list = fileUrls.split(",");
        list.forEach(url => {
          datas.fileList.push({
            id: getUUID(),
            url: url,
            fileSuffix: props.fileSuffix ? props.fileSuffix : "png",
          });
        })
      }
    }, { immediate: true })


    return {
      ...toRefs(datas),
      ...methods,
      imageRef,
      gljyImgPreviewRef
    }
  }
}
</script>

<style lang="scss" scoped>
.file-box {
  display: flex;
  flex-wrap: wrap;

  .fileitem-box {
    width: 80px;
    height: 80px;
    margin-right: 10px;

    .image-class {
      width: 100%;
      height: 100%;
    }
  }
}</style>